import { createSlice } from "@reduxjs/toolkit";

import { changeRowDataRecourse } from "../utils";

const initialState = {
	headerData: {},
	tableData: [],
	fetchStatus: null,
	fetchStatusText: null,
	editorMode: "",
	undoActions: [],
	redoActions: [],
	visibleSettings: {},
	visibleChangeCount: 0,
	fileLinksMap: {},
	modalVisible: { deleteConfirm: false, settings: false, files: false },
	pdfVisible: false,
	pdfBlobData: null,
	pdfBlobName: "",
	pdfTargetPage: null,
	itemsBuffer: [],
	itemsBufferAction: "",
};

export const vorEditorSlice = createSlice({
	name: "vorEditor",
	initialState,
	reducers: {
		setHeaderData: (state, { payload }) => {
			state.headerData = payload;
		},
		setTableData: (state, { payload }) => {
			state.tableData = payload;
		},
		setFetchStatus: (state, { payload }) => {
			state.fetchStatus = payload;
		},
		setFetchStatusText: (state, { payload }) => {
			state.fetchStatusText = payload;
		},
		setEditorMode: (state, { payload }) => {
			state.editorMode = payload;
		},
		setUndoActions: (state, { payload }) => {
			state.undoActions = payload;
		},
		setRedoActions: (state, { payload }) => {
			state.redoActions = payload;
		},
		setVisibleSettings: (state, { payload }) => {
			state.visibleSettings = payload;
		},
		updateVisibleSettings: (state, { payload }) => {
			const key = Object.keys(payload)[0];
			const newPayload = { ...payload[key] };
			const prevPayload = state.visibleSettings?.[key] || {};
			const payloadNewAndPrev = { [key]: { ...prevPayload, ...newPayload } };
			state.visibleSettings = { ...state.visibleSettings, ...payloadNewAndPrev };
			state.visibleChangeCount = state.visibleChangeCount + 1;
		},
		increaseVisibleChangeCount: (state) => {
			state.visibleChangeCount = state.visibleChangeCount + 1;
		},
		setFileLinksMap: (state, { payload }) => {
			state.fileLinksMap = payload;
		},
		changeRowData: (state, { payload: { rowKey, callback } }) => {
			state.tableData = changeRowDataRecourse(state.tableData, rowKey, callback);
		},
		setModalVisible: (state, { payload }) => {
			state.modalVisible = { ...state.modalVisible, ...payload };
		},
		setCacheJson: (state, { payload }) => {
			state.headerData = payload.header_data;
			state.tableData = payload.table_data;
			state.undoActions = payload.actions_data;
			state.redoActions = payload.redo_data;
			state.fileLinksMap = payload.file_links_map;
			state.visibleSettings = payload.visible_settings;
		},
		setPdfVisible: (state, { payload }) => {
			state.pdfVisible = payload;
		},
		setPdfBlobData: (state, { payload }) => {
			state.pdfBlobData = payload;
		},
		setPdfBlobName: (state, { payload }) => {
			state.pdfBlobName = payload;
		},
		setPdfTargetPage: (state, { payload }) => {
			state.pdfTargetPage = payload;
		},
		setItemsBuffer: (state, { payload }) => {
			state.itemsBuffer = payload.items;
			state.itemsBufferAction = payload.action;
		},
	},
});

export const { actions: vorEditorActions, reducer: vorEditorReducer } = vorEditorSlice;
